import { setUsrAppRefreshParams } from '@jfs/network'
import { Box, ColorOptions, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { FC, useEffect, useState } from 'react'
import { FlatList } from 'react-native'
import Tabbar, { TabbarType } from '../../components/Tabbar'
import { useStores } from '../../data/store'
import { AppHeaderTransformer, extendAppSession } from '../../network/ExtendAppSession'
import { HeaderTransformer, extendUserSession } from '../../network/ExtendUserSession'
import { convertHexToRGBA } from '../../utils'
import styles from './styles'

const dataList = [
  { title: 'Activated', count: '876' },
  { title: 'Suspended', count: '20' },
  { title: 'Terminated', count: '10' },
]
const GridBoxItem = ({ index, data }: any) => {
  const getBgColor = () => {
    return index === 0
      ? convertHexToRGBA('4BA345', 6)
      : index === 1
      ? convertHexToRGBA('E68E00', 6)
      : convertHexToRGBA('C94949', 6)
  }
  return (
    <ModBox backgroundColor={getBgColor() as ColorOptions} flex={1} margin={12} borderRadius={8}>
      <ModBox padding={32}>
        <Text title={data?.title} color={'BLACK_75'} fontSize={14} fontFamily={'jiotype-medium'} />
        <Spacer size={16} />
        <Text title={data?.count} color={'BLACK_21'} fontSize={26} fontFamily={'jiotype-bold'} />
      </ModBox>
    </ModBox>
  )
}

const DISABLE_EMS_STATISTICS = true

const Home: FC = () => {
  const { username, updateAllSessionData, usrAccessToken, usrRefreshToken, appAccessToken, appRefreshToken } =
    useStores((root) => ({
      updateAllSessionData: root.session.updateAllSessionData,
      usrAccessToken: root?.session?.usrAccessToken,
      usrRefreshToken: root?.session?.usrRefreshToken,
      appAccessToken: root?.session?.appAccessToken,
      appRefreshToken: root?.session?.appRefreshToken,
      username: root.user.name,
    }))
  const defaultTitles = [{ title: 'Overall' }, { title: 'Last 7 Days' }]
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)

  useEffect(() => {
    setUsrAppRefreshParams(
      () => extendUserSession(username, usrAccessToken, usrRefreshToken),
      HeaderTransformer,
      () => extendAppSession(appAccessToken, appRefreshToken),
      AppHeaderTransformer,
    )
  }, [appAccessToken, appRefreshToken, username, usrAccessToken, usrRefreshToken])

  const navigation = useNavigation()
  const getFromLocal = () => {
    const sData = localStorage.getItem('sessionData')
    if (sData !== null && sData.length > 0) {
      updateAllSessionData(JSON.parse(sData))
    } else {
      navigation.reset({
        index: 0,
        routes: [{ name: 'login' }],
      })
    }
  }

  useEffect(() => {
    getFromLocal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appAccessToken])

  const onSelected = (selectedIndex: number) => {
    console.log('selectedIndex: ', selectedIndex)
    setSelectedTabIndex(selectedIndex)
  }

  const renderItem = ({ index, item }: any) => {
    return <GridBoxItem index={index} data={item} />
  }

  if (DISABLE_EMS_STATISTICS) {
    return (
      <Box flex={1} justifyContent="center" alignItems={'center'} backgroundColor="WHITE">
        <Text fontSize={18} fontFamily={'jiotype-bold'} color={'BLACK_21'}>
          Welcome to Operations Portal
        </Text>
        {/* <Documentation type={''} /> */}
      </Box>
    )
  }
  return (
    <Box {...styles.contantViewStyle}>
      <ModBox h={24}>
        <Text title={'Onboarding Summary'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
      </ModBox>
      <ModBox marginTop={24}>
        <Tabbar
          titles={defaultTitles}
          default={selectedTabIndex}
          type={TabbarType.recentPayments}
          onSelected={onSelected}
        />
      </ModBox>
      <Box marginTop={32} height={'100%'}>
        <FlatList renderItem={renderItem} data={dataList} numColumns={3} />
        {/* <Settings type={EmType.createSingleEntity} /> */}
      </Box>
    </Box>
  )
}

export default Home
